var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonePay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_297_1072)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_1072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9109 1.25246C25.0625 0.343801 21.0311 0.596685 17.3265 1.97913C13.6218 3.36158 10.4102 5.81151 8.09792 9.01913C5.78558 12.2268 4.47631 16.048 4.33566 19.9997C4.195 23.9514 5.22928 27.8561 7.30771 31.22C9.38613 34.5839 12.4154 37.256 16.0124 38.8983C19.6094 40.5406 23.6126 41.0795 27.5158 40.4468C31.4191 39.814 35.0471 38.0381 37.941 35.3435C40.835 32.6489 42.8649 29.1567 43.7742 25.3084C44.378 22.753 44.4725 20.1036 44.0523 17.5115C43.6322 14.9195 42.7055 12.4357 41.3253 10.2018C39.9451 7.96796 38.1383 6.02787 36.0083 4.49232C33.8782 2.95678 31.4665 1.85587 28.9109 1.25246Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3903 15.494C33.3795 15.1139 33.2226 14.7526 32.9522 14.4853C32.6818 14.2179 32.3187 14.065 31.9385 14.0585H29.2562L23.1136 7.00445C22.8263 6.6816 22.4531 6.44713 22.0375 6.3284C21.6219 6.20966 21.1811 6.21156 20.7666 6.33388L18.6377 7.00445C18.5621 7.0301 18.4937 7.07368 18.4386 7.13148C18.3835 7.18927 18.3431 7.25956 18.3211 7.33633C18.299 7.4131 18.2958 7.49407 18.3119 7.57232C18.3279 7.65058 18.3626 7.72379 18.4131 7.7857L25.1221 14.1529H14.9593C14.8855 14.1496 14.8118 14.1618 14.743 14.1887C14.6741 14.2155 14.6117 14.2565 14.5596 14.3089C14.5075 14.3613 14.4669 14.424 14.4405 14.493C14.414 14.562 14.4022 14.6357 14.4059 14.7095V15.8261C14.4126 16.209 14.5677 16.5744 14.8386 16.8453C15.1094 17.1161 15.4748 17.2712 15.8578 17.2779H17.4235V22.6425C17.4235 26.6627 19.5459 29.0097 23.1201 29.0097C24.1905 29.0425 25.2559 28.8518 26.2484 28.4498V32.0305C26.2453 32.266 26.2895 32.4998 26.3782 32.718C26.4669 32.9362 26.5984 33.1344 26.765 33.301C26.9316 33.4676 27.1298 33.5991 27.348 33.6878C27.5662 33.7765 27.8 33.8207 28.0355 33.8176H29.598C29.7718 33.8055 29.9354 33.7309 30.0587 33.6077C30.1819 33.4845 30.2564 33.3209 30.2686 33.147V17.1705H32.8304C32.9051 17.1747 32.9798 17.1631 33.0496 17.1365C33.1195 17.1099 33.1829 17.0688 33.2358 17.0159C33.2886 16.9631 33.3297 16.8996 33.3564 16.8298C33.383 16.7599 33.3946 16.6852 33.3903 16.6106V15.494ZM26.2289 25.1002C25.5243 25.4083 24.7614 25.5605 23.9925 25.5461C22.2054 25.5461 21.3135 24.6542 21.3135 22.6425V17.2811H26.2289V25.0936V25.1002Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_297_1072",
    x: 0.314697,
    y: 0.712158,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_297_1072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_297_1072",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.3147,
    y: 0.712158,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePay);
export default __webpack_public_path__ + "static/media/phonePay.cff5970063348b5235c10128e7007b8e.svg";
export { ForwardRef as ReactComponent };